import { createShare, markShareSent } from './sharesApi.jsx';

// اشتراک‌گذاری با لینک — برنامه چت ندارد؛ لینک با برنامه‌های دیگر (واتس‌اپ، تلگرام، اینستاگرام، پیامک …) فرستاده
// می‌شود. لینکِ /d/<id> روی سرور پیش‌نمایش (عکس، عنوان، قیمت) دارد و با باز شدن، همان طرح تمام‌صفحه نشان داده می‌شود
const fa = (n) => Number(n).toLocaleString('fa-IR');

export function designLink(id) {
  return `${window.location.origin}/d/${id}`;
}

function shareText(d) {
  const l = d.listing || {};
  const parts = [];
  if (l.dealType === 'rent') {
    if (l.deposit) parts.push(`ودیعه ${fa(l.deposit)}`);
    if (l.rent) parts.push(`اجاره ${fa(l.rent)}`);
  } else if (l.price) parts.push(`${fa(l.price)} تومان`);
  if (l.area) parts.push(`${fa(l.area)} متر`);
  if (l.province) parts.push(l.province);
  return [l.title, parts.join(' · '), 'تورِ سه‌بعدی در خونه‌رو 👇'].filter(Boolean).join('\n');
}

// لینکِ اختصاصیِ همین فرستنده (/s/<code>) — بازدیدها در تبِ «شیر» دیده می‌شوند و همین کد «اتاقِ» بازدیدِ مشترک
// است. اگر سرور در دسترس نبود، لینکِ ساده‌ی طرح
// آیفون اجازه‌ی «اشتراک» را فقط بلافاصله بعد از لمس می‌دهد — پس کد از قبل (وقتی طرح روی صفحه آمد) گرفته می‌شود
const codes = new Map(); // designId → Promise<code|null>
export function prepareShare(design) {
  if (!design || !design.id) return;
  if (!codes.has(design.id)) {
    codes.set(
      design.id,
      createShare(design.id)
        .then((r) => (r && r.code) || null)
        .catch(() => {
          codes.delete(design.id);
          return null;
        })
    );
  }
}

async function linkFor(design) {
  prepareShare(design);
  const code = await Promise.race([codes.get(design.id) || null, new Promise((r) => setTimeout(() => r(null), 2500))]);
  return { code, url: code ? `${window.location.origin}/s/${code}` : designLink(design.id) };
}

// برای منوی «اشتراک» خودمان (پیامک اول): لینک + متن آماده
export async function shareLinkFor(design) {
  const { code, url } = await linkFor(design);
  return { code, url, text: shareText(design) };
}

// → 'shared' | 'copied' | 'cancelled' | 'failed'
// بعد از فرستادن/کپی، لینک در تبِ «شیر» ← «فرستاده‌ها» می‌آید (با «هنوز دیده نشده» تا وقتی گیرنده بازش کند)
export async function shareDesign(design) {
  const { code, url } = await linkFor(design);
  const sent = (r) => {
    if (code) markShareSent(code);
    return r;
  };
  const text = shareText(design);
  if (navigator.share) {
    try {
      await navigator.share({ title: (design.listing && design.listing.title) || 'خونه‌رو', text, url });
      return sent('shared');
    } catch (e) {
      if (e && e.name === 'AbortError') return 'cancelled';
    }
  }
  try {
    await navigator.clipboard.writeText(`${text}\n${url}`);
    return sent('copied');
  } catch (e) {
    // مرورگرهای قدیمی
    const ta = document.createElement('textarea');
    ta.value = `${text}\n${url}`;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    let ok = false;
    try {
      ok = document.execCommand('copy');
    } catch (e2) {
      ok = false;
    }
    ta.remove();
    return ok ? sent('copied') : 'failed';
  }
}
